import { ALL_MORTGAGE_SCENARIO_DEFAULT_PARAMS } from '../definitions/DefaultParameters';
import fetchAllRates from './fetchAllRates';
import sortRatesByFeaturedAndValue from './sortRatesByFeaturedAndValue';


export default async function fetchFeaturedRatesSortedByLowest({ scenario, callerName, ...params }) {
    const rates = await fetchAllRates(scenario, {
        ...ALL_MORTGAGE_SCENARIO_DEFAULT_PARAMS[scenario],
        ...params,
    }, { callerName });

    if (!rates) {
        return null;
    }

    const filteredRates = rates.filter(rate => !rate.cpcLink && !rate.cpaLink);

    return sortRatesByFeaturedAndValue(filteredRates);
}
